export const MINIMETAS_MILESTONES = [10, 20, 30, 50, 100] as const
export const REI_IMEDIATOS_MILESTONES = [500, 1000] as const
export const BATEU_LEVOU_GOAL = 3000
const BATEU_LEVOU_QUASE_LA_MARGIN = 500
const MINIMETAS_QUASE_LA_MARGIN = 5

export function normalizeReferenceMonthKey(referenceMonth: string): string {
  const trimmed = (referenceMonth ?? '').trim()
  const match = trimmed.match(/^(\d{4})-(\d{2})/)
  if (match) return `${match[1]}-${match[2]}`
  return trimmed
}

export function formatReferenceMonth(referenceMonth: string): string {
  const key = normalizeReferenceMonthKey(referenceMonth)
  const [year, month] = key.split('-')
  if (year && month) return `${month}/${year}`
  return referenceMonth
}

export function getAchievedMinimetasMilestones(qty: number): number[] {
  return MINIMETAS_MILESTONES.filter((m) => qty >= m)
}

export function getNextMinimetasMilestone(qty: number): number | null {
  return MINIMETAS_MILESTONES.find((m) => qty < m) ?? null
}

export function getAchievedReiMilestones(qty: number): number[] {
  return REI_IMEDIATOS_MILESTONES.filter((m) => qty >= m)
}

export function getNextReiMilestone(qty: number): number | null {
  return REI_IMEDIATOS_MILESTONES.find((m) => qty < m) ?? null
}

export function isAlmostAtBateuLevouGoal(paidPremium: number): boolean {
  return paidPremium < BATEU_LEVOU_GOAL && paidPremium >= BATEU_LEVOU_GOAL - BATEU_LEVOU_QUASE_LA_MARGIN
}

export function getBateuLevouGoalStatus(paidPremium: number, formatCurrency: (v: number) => string): string {
  if (paidPremium >= BATEU_LEVOU_GOAL) return 'Bateu a meta ✓'
  if (isAlmostAtBateuLevouGoal(paidPremium)) {
    return `Quase lá - faltam ${formatCurrency(BATEU_LEVOU_GOAL - paidPremium)}`
  }
  return `Faltam ${formatCurrency(Math.max(0, BATEU_LEVOU_GOAL - paidPremium))}`
}
